<div class="settings-container">
  <h1 class="page-title">{{ "settings.title" | translate }}</h1>

  <!-- ── LINGUA ───────────────────────────────────────────── -->
  <section class="settings-section" [class.open]="openSection === 'lang'">
    <button type="button" class="settings-head" (click)="toggleSection('lang')" [attr.aria-expanded]="openSection === 'lang'">
      <span class="settings-icon"><app-icon name="globe" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ "settings.lang.title" | translate }}</h2>
      <span class="settings-value">{{ currentLangLabel }}</span>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ "settings.lang.desc" | translate }}</p>
      <div class="lang-chips">
        <button
          *ngFor="let l of langs"
          class="lang-chip"
          [class.active]="currentLang === l.code"
          (click)="changeLang(l.code)"
        >{{ l.label }}</button>
      </div>
    </div>
  </section>

  <!-- ── NOTIFICHE EMAIL ───────────────────────────────────── -->
  <section class="settings-section" [class.open]="openSection === 'notif'">
    <button type="button" class="settings-head" (click)="toggleSection('notif')" [attr.aria-expanded]="openSection === 'notif'">
      <span class="settings-icon"><app-icon name="mail" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ "settings.notifications.title" | translate }}</h2>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <div class="notif-banner">
        <span class="notif-banner-icon"><app-icon name="mail" [size]="20" /></span>
        <div>
          <p class="notif-banner-title">{{ 'settings.notifications.banner_title' | translate }}</p>
          <p class="notif-banner-desc">{{ 'settings.notifications.banner_desc' | translate }}</p>
        </div>
      </div>

      <app-load-error *ngIf="loadError" (retry)="load()"></app-load-error>
      <div class="notif-list" *ngIf="!loadError">
        <div *ngFor="let key of notificationItems" class="notif-row">
          <div class="notif-info">
            <span class="notif-label">{{ "settings.notifications.items." + key + ".label" | translate }}</span>
            <span class="notif-desc">{{ "settings.notifications.items." + key + ".desc" | translate }}</span>
          </div>
          <div class="notif-actions">
            <button
              class="test-btn"
              [class.loading]="sendingTest === key"
              [disabled]="sendingTest !== null"
              (click)="sendTest(key)"
              [title]="'settings.notifications.test' | translate"
              [attr.aria-label]="'settings.notifications.test' | translate"
            >
              <ng-container *ngIf="sendingTest === key; else mailIcon">...</ng-container><ng-template #mailIcon><app-icon name="mail" [size]="15" /></ng-template>
            </button>
            <button
              class="toggle-btn"
              [class.on]="getNotif(key)"
              (click)="toggleNotif($any(key))"
              [attr.aria-pressed]="getNotif(key)"
              [attr.aria-label]="'settings.notifications.items.' + key + '.label' | translate"
            >
              <span class="toggle-knob"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── TOUR & GUIDA ──────────────────────────────────────── -->
  <!-- PREVENTIVI -->
  <section class="settings-section" [class.open]="openSection === 'quote'">
    <button type="button" class="settings-head" (click)="toggleSection('quote')" [attr.aria-expanded]="openSection === 'quote'">
      <span class="settings-icon"><app-icon name="note" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ "quote.settings.title" | translate }}</h2>
      <span class="settings-value" *ngIf="!loadError">{{ quoteValidityDays }} {{ "quote.settings.days" | translate }}</span>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ "quote.settings.desc" | translate }}</p>
      <app-load-error *ngIf="loadError" (retry)="load()"></app-load-error>
      <label class="quote-validity" *ngIf="!loadError">
        <input type="number" min="1" max="90" step="1" inputmode="numeric" [(ngModel)]="quoteValidityDays" (change)="saveQuoteValidity()" />
        <span>{{ "quote.settings.days" | translate }}</span>
      </label>
    </div>
  </section>

  <section class="settings-section" [class.open]="openSection === 'tour'">
    <button type="button" class="settings-head" (click)="toggleSection('tour')" [attr.aria-expanded]="openSection === 'tour'">
      <span class="settings-icon"><app-icon name="sparkle" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ 'settings.tour.section_title' | translate }}</h2>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ 'settings.tour.section_desc' | translate }}</p>
      <div class="tour-list">
        <div *ngFor="let t of tours" class="tour-row">
          <span class="tour-label">{{ t.label | translate }}</span>
          <button class="btn-outline-sm" (click)="resetTour(t)">{{ 'settings.tour.review' | translate }}</button>
        </div>
      </div>
      <button class="btn-ghost" (click)="resetAllTours()">{{ 'settings.tour.review_all' | translate }}</button>
    </div>
  </section>

  <section class="settings-section" [class.open]="openSection === 'wizard'">
    <button type="button" class="settings-head" (click)="toggleSection('wizard')" [attr.aria-expanded]="openSection === 'wizard'">
      <span class="settings-icon"><app-icon name="file" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ 'settings.contract_wizard.section_title' | translate }}</h2>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ 'settings.contract_wizard.section_desc' | translate }}</p>
      <button class="btn-outline-sm" (click)="openContractWizard()">{{ 'settings.contract_wizard.review' | translate }}</button>
    </div>
  </section>

  <!-- ── VISIBILITÀ SEZIONI ────────────────────────────────── -->
  <section class="settings-section" [class.open]="openSection === 'visibility'">
    <button type="button" class="settings-head" (click)="toggleSection('visibility')" [attr.aria-expanded]="openSection === 'visibility'">
      <span class="settings-icon"><app-icon name="eye" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ 'profile.visibility.title' | translate }}</h2>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ 'profile.visibility.subtitle' | translate }}</p>

      <app-load-error *ngIf="loadError" (retry)="load()"></app-load-error>
      <ng-container *ngIf="!loadError">
      <div class="vis-table">
        <div class="vis-row vis-head">
          <span class="vis-section-label"></span>
          <span class="vis-col-label">{{ 'profile.visibility.collaborators' | translate }}</span>
          <span class="vis-col-label">{{ 'profile.visibility.team' | translate }}</span>
        </div>
        <div class="vis-row" *ngFor="let s of visibilitySections">
          <span class="vis-section-label">{{ s.label | translate }}</span>
          <button
            class="toggle-btn"
            [class.on]="collaboratorVisibility[s.key]"
            (click)="toggleCollaboratorVisibility(s.key)"
            [attr.aria-pressed]="collaboratorVisibility[s.key]"
          >
            <span class="toggle-knob"></span>
          </button>
          <button
            class="toggle-btn"
            [class.on]="teamVisibility[s.key]"
            (click)="toggleTeamVisibility(s.key)"
            [attr.aria-pressed]="teamVisibility[s.key]"
          >
            <span class="toggle-knob"></span>
          </button>
        </div>
      </div>

      <button class="btn-outline-sm vis-save" (click)="saveVisibility()">
        {{ 'profile.visibility.save' | translate }}
      </button>
      </ng-container>
    </div>
  </section>

  <!-- ── ASSISTENZA ────────────────────────────────────────── -->
  <section class="settings-section" [class.open]="openSection === 'support'">
    <button type="button" class="settings-head" (click)="toggleSection('support')" [attr.aria-expanded]="openSection === 'support'">
      <span class="settings-icon"><app-icon name="chat" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ 'settings.support.section_title' | translate }}</h2>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ 'settings.support.section_desc' | translate }}</p>
      <div class="action-row">
        <div class="action-info">
          <p class="action-label">{{ 'settings.support.chat_label' | translate }}</p>
          <p class="action-desc">{{ 'settings.support.chat_desc' | translate }}</p>
        </div>
        <button class="btn-outline-sm" (click)="openSupportChat()">{{ 'settings.support.chat_cta' | translate }}</button>
      </div>
    </div>
  </section>

  <!-- ── ACCOUNT ───────────────────────────────────────────── -->
  <section class="settings-section" [class.open]="openSection === 'account'">
    <button type="button" class="settings-head" (click)="toggleSection('account')" [attr.aria-expanded]="openSection === 'account'">
      <span class="settings-icon"><app-icon name="lock" [size]="17"></app-icon></span>
      <h2 class="section-title">{{ "settings.account.title" | translate }}</h2>
      <span class="settings-chevron">›</span>
    </button>
    <div class="settings-body">
      <p class="section-desc">{{ "settings.account.desc" | translate }}</p>
      <div class="action-row">
        <div class="action-info">
          <p class="action-label">{{ "settings.account.password_label" | translate }}</p>
          <p class="action-desc">{{ "settings.account.password_desc" | translate }}</p>
        </div>
        <button class="btn-outline-sm" (click)="goToProfile()">{{ "settings.account.go_profile" | translate }}</button>
      </div>
      <div class="action-row muted">
        <div class="action-info">
          <p class="action-label">{{ "settings.account.delete_label" | translate }}</p>
          <p class="action-desc">{{ "settings.account.delete_desc" | translate }}</p>
        </div>
        <span class="wip-tag"><app-icon name="alert" [size]="12" /> {{ "settings.account.wip" | translate }}</span>
      </div>
    </div>
  </section>

</div>
